
import { isChildOf } from "../utils/dom";
import Vue from "vue";
import { ISelectItem } from "../classes";

export default Vue.extend({
	data() {
		return {
			isOpened: false,
			isMouseDown: false,
			shouldGoUpOnAutoUp: false
		};
	},
	props: {
		items: Array as () => ISelectItem<any>[],
		up: {
			type: Boolean,
			default: false
		},
		triggerClass: String,
		flat: {
			type: Boolean,
			default: false
		},
		round: Boolean,
		sm: Boolean,
		// eslint-disable-next-line vue/require-prop-types
		value: {},
		lg: Boolean,
		xl: Boolean,
		right: Boolean,
		center: Boolean,
		disabled: Boolean,
		icon: [String, Array as ()=>string[]],
		useLink: Boolean,
		white: Boolean,
		autoUp: Boolean,
		thin: Boolean,
		thinRight: Boolean,
		thinLeft: Boolean
	},
	computed: {
		triggerClasses():string[] {
			let result = [] as string[];
			if (this.center) {
				result.push("center");
			}
			if (this.triggerClass) {
				result.push(this.triggerClass);
			}
			return result;
		},
		shouldGoUp():boolean {
			if (this.up) {
				return true;
			}
			if (this.autoUp){
				return this.shouldGoUpOnAutoUp;
			}
			return false;
		}
	},
	watch: {
		isOpened: {
			handler(){
				if (!this.isOpened) return;
				let rect = this.$el.getBoundingClientRect();
				this.shouldGoUpOnAutoUp = false;
				if (rect.y > window.innerHeight / 2) {
					this.shouldGoUpOnAutoUp = true;
				}
			}
		}
	},
	methods: {
		itemClicked(event:Event, item: ISelectItem<any>) {
			if (item.disabled) return;
			event.preventDefault();
			this.$emit("click", item.value);
			this.isOpened = false;
		},
		onItemMouseDown(){
			this.isMouseDown = true;
		},
		async onBlur(){
			if (this.isMouseDown) return;
			let itemContainer = this.$refs.itemContainer as Vue;
			if (!itemContainer) return;
			let el = itemContainer.$el as HTMLElement;
			if (!document.activeElement) return;
			if (isChildOf(el, document.activeElement as HTMLElement)) return;
			this.isOpened = false;
		},
		onMouseUp(){
			this.isMouseDown = false;
		},
		onMouseDown(){
			this.onBlur();
		}
	},
	created(){
		window.addEventListener("mouseup", this.onMouseUp);
		window.addEventListener("mousedown", this.onMouseDown);
	},
	destroyed(){
		window.removeEventListener("mouseup", this.onMouseUp);
		window.removeEventListener("mousedown", this.onMouseDown);
	}
});
